import { useContext } from "react";

import headingLevelContext from "./headingLevelContext";

export default function Section({ children, adjustLevel = 1 }) {
  let level = useContext(headingLevelContext);
  return (
    <headingLevelContext.Provider value={level + adjustLevel}>
      {children}
    </headingLevelContext.Provider>
  );
}
